import axios from "../../config/axios";

const state = {
    stripe: '',
};

const getters = {
    getStripe: state => state.stripe
}
const mutations = {
    setStripe(state, stripe) {
        state.stripe = stripe
    }
}
const actions = {
    store: async ({ commit, dispatch }, params) => {
        try {
            const response = await axios.post('payments', params);
            commit('errors/setMessage', response.data.message ,{ root: true });
            commit('payments/setStripe', '', { root: true });
            commit('orders/setOrder', '', { root: true });
        }catch(e) {
            await dispatch('errors/errorResponse', e.response, {root: true});
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
